function regValidate( value, errorMsg) {
  if (value) {
    return errorMsg;
  }
}

function cbRegValidate(cb, value, errorMsg) {
  if (typeof cb === 'function') {
    return cb.call(this, value, errorMsg)
  } else  {
    var REG = new RegExp(cb);
    if (!REG.test(value ?? '' )) {
      return errorMsg;
    }
  }
}

const Validator = function() {
  this.cache = [];
}

Validator.prototype.add = function(value, errorMsg) {
  this.cache.push(function() {
    return regValidate.call(this, value, errorMsg);
  });
}

Validator.prototype.cbAdd = function(value, cb, errorMsg) {
  this.cache.push(function() {
    return cbRegValidate.call(this, cb, value, errorMsg);
  });
}

Validator.prototype.start = function() {
  for (let i = 0, validatorFunc; validatorFunc = this.cache[i++];) {
    const msg = validatorFunc();
    if (msg) {
      return msg;
    }
  }
};

export default Validator;